<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-form-field style="width: 100%;">
    <mat-label>{{data.detail}}</mat-label>
    <input type="{{type}}" autocomplete="off" matInput [(ngModel)]="data.content">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <div class="filler"></div>
  <button mat-button (click)="onCancel()">{{data.cancel}}</button>
  <button mat-button [mat-dialog-close]="data.content" cdkFocusInitial>{{data.accept}}</button>
</div>